// extracted by mini-css-extract-plugin
export default {"boonIconBtn":"ButtonWithIcon_boonIconBtn__37y03","btnIconStyle":"ButtonWithIcon_btnIconStyle__kM7OY","btnIconText":"ButtonWithIcon_btnIconText__Of2bv"};